/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './pages/__root';
import { Route as IndexRouteImport } from './pages/index';
import { Route as ConformidadeRouteImport } from './pages/conformidade';
import { Route as InicioRouteImport } from './pages/inicio';
import { Route as TestesEndpointRouteImport } from './pages/testes-endpoint';
import { Route as AplicacoesIndexRouteImport } from './pages/aplicacoes/index';
import { Route as ConsentimentosIndexRouteImport } from './pages/consentimentos/index';
import { Route as ConviteIndexRouteImport } from './pages/convite/index';
import { Route as DcrIndexRouteImport } from './pages/dcr/index';
import { Route as DocumentacaoIndexRouteImport } from './pages/documentacao/index';
import { Route as DocumentacaoApiRouteImport } from './pages/documentacao/$api';
import { Route as DriftRegulatorioIndexRouteImport } from './pages/drift-regulatorio/index';
import { Route as IndicadoresIndexRouteImport } from './pages/indicadores/index';
import { Route as LoginIndexRouteImport } from './pages/login/index';
import { Route as MonitoramentoIndexRouteImport } from './pages/monitoramento/index';
import { Route as OnboardingIndexRouteImport } from './pages/onboarding/index';
import { Route as OnboardingPChar123phaseIdChar125RouteImport } from './pages/onboarding/p{$phaseId}';
import { Route as OperacoesIndexRouteImport } from './pages/operacoes/index';
import { Route as OperacoesBuscaRouteImport } from './pages/operacoes/busca';
import { Route as OperacoesDlqRouteImport } from './pages/operacoes/dlq';
import { Route as PcmIndexRouteImport } from './pages/pcm/index';
import { Route as PrimeirosPassosIndexRouteImport } from './pages/primeiros-passos/index';
import { Route as ReceptoraIndexRouteImport } from './pages/receptora/index';
import { Route as ReceptoraNovaRouteImport } from './pages/receptora/nova';
import { Route as ReceptoraRetornoRouteImport } from './pages/receptora/retorno';
import { Route as ReceptoraTitularRouteImport } from './pages/receptora/titular';
import { Route as RelatorioDiretorIndexRouteImport } from './pages/relatorio-diretor/index';
import { Route as UsuariosIndexRouteImport } from './pages/usuarios/index';
import { Route as ReceptoraConexoesIdRouteImport } from './pages/receptora/conexoes/$id';
import { Route as OnboardingEvidenceChar123phaseDirChar125Char123runIdChar125RouteImport } from './pages/onboarding/evidence/{$phaseDir}.{$runId}';

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any);
const ConformidadeRoute = ConformidadeRouteImport.update({
  id: '/conformidade',
  path: '/conformidade',
  getParentRoute: () => rootRouteImport,
} as any);
const InicioRoute = InicioRouteImport.update({
  id: '/inicio',
  path: '/inicio',
  getParentRoute: () => rootRouteImport,
} as any);
const TestesEndpointRoute = TestesEndpointRouteImport.update({
  id: '/testes-endpoint',
  path: '/testes-endpoint',
  getParentRoute: () => rootRouteImport,
} as any);
const AplicacoesIndexRoute = AplicacoesIndexRouteImport.update({
  id: '/aplicacoes/',
  path: '/aplicacoes/',
  getParentRoute: () => rootRouteImport,
} as any);
const ConsentimentosIndexRoute = ConsentimentosIndexRouteImport.update({
  id: '/consentimentos/',
  path: '/consentimentos/',
  getParentRoute: () => rootRouteImport,
} as any);
const ConviteIndexRoute = ConviteIndexRouteImport.update({
  id: '/convite/',
  path: '/convite/',
  getParentRoute: () => rootRouteImport,
} as any);
const DcrIndexRoute = DcrIndexRouteImport.update({
  id: '/dcr/',
  path: '/dcr/',
  getParentRoute: () => rootRouteImport,
} as any);
const DocumentacaoIndexRoute = DocumentacaoIndexRouteImport.update({
  id: '/documentacao/',
  path: '/documentacao/',
  getParentRoute: () => rootRouteImport,
} as any);
const DocumentacaoApiRoute = DocumentacaoApiRouteImport.update({
  id: '/documentacao/$api',
  path: '/documentacao/$api',
  getParentRoute: () => rootRouteImport,
} as any);
const DriftRegulatorioIndexRoute = DriftRegulatorioIndexRouteImport.update({
  id: '/drift-regulatorio/',
  path: '/drift-regulatorio/',
  getParentRoute: () => rootRouteImport,
} as any);
const IndicadoresIndexRoute = IndicadoresIndexRouteImport.update({
  id: '/indicadores/',
  path: '/indicadores/',
  getParentRoute: () => rootRouteImport,
} as any);
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => rootRouteImport,
} as any);
const MonitoramentoIndexRoute = MonitoramentoIndexRouteImport.update({
  id: '/monitoramento/',
  path: '/monitoramento/',
  getParentRoute: () => rootRouteImport,
} as any);
const OnboardingIndexRoute = OnboardingIndexRouteImport.update({
  id: '/onboarding/',
  path: '/onboarding/',
  getParentRoute: () => rootRouteImport,
} as any);
const OnboardingPChar123phaseIdChar125Route =
  OnboardingPChar123phaseIdChar125RouteImport.update({
    id: '/onboarding/p{$phaseId}',
    path: '/onboarding/p{$phaseId}',
    getParentRoute: () => rootRouteImport,
  } as any);
const OperacoesIndexRoute = OperacoesIndexRouteImport.update({
  id: '/operacoes/',
  path: '/operacoes/',
  getParentRoute: () => rootRouteImport,
} as any);
const OperacoesBuscaRoute = OperacoesBuscaRouteImport.update({
  id: '/operacoes/busca',
  path: '/operacoes/busca',
  getParentRoute: () => rootRouteImport,
} as any);
const OperacoesDlqRoute = OperacoesDlqRouteImport.update({
  id: '/operacoes/dlq',
  path: '/operacoes/dlq',
  getParentRoute: () => rootRouteImport,
} as any);
const PcmIndexRoute = PcmIndexRouteImport.update({
  id: '/pcm/',
  path: '/pcm/',
  getParentRoute: () => rootRouteImport,
} as any);
const PrimeirosPassosIndexRoute = PrimeirosPassosIndexRouteImport.update({
  id: '/primeiros-passos/',
  path: '/primeiros-passos/',
  getParentRoute: () => rootRouteImport,
} as any);
const ReceptoraIndexRoute = ReceptoraIndexRouteImport.update({
  id: '/receptora/',
  path: '/receptora/',
  getParentRoute: () => rootRouteImport,
} as any);
const ReceptoraNovaRoute = ReceptoraNovaRouteImport.update({
  id: '/receptora/nova',
  path: '/receptora/nova',
  getParentRoute: () => rootRouteImport,
} as any);
const ReceptoraRetornoRoute = ReceptoraRetornoRouteImport.update({
  id: '/receptora/retorno',
  path: '/receptora/retorno',
  getParentRoute: () => rootRouteImport,
} as any);
const ReceptoraTitularRoute = ReceptoraTitularRouteImport.update({
  id: '/receptora/titular',
  path: '/receptora/titular',
  getParentRoute: () => rootRouteImport,
} as any);
const RelatorioDiretorIndexRoute = RelatorioDiretorIndexRouteImport.update({
  id: '/relatorio-diretor/',
  path: '/relatorio-diretor/',
  getParentRoute: () => rootRouteImport,
} as any);
const UsuariosIndexRoute = UsuariosIndexRouteImport.update({
  id: '/usuarios/',
  path: '/usuarios/',
  getParentRoute: () => rootRouteImport,
} as any);
const ReceptoraConexoesIdRoute = ReceptoraConexoesIdRouteImport.update({
  id: '/receptora/conexoes/$id',
  path: '/receptora/conexoes/$id',
  getParentRoute: () => rootRouteImport,
} as any);
const OnboardingEvidenceChar123phaseDirChar125Char123runIdChar125Route =
  OnboardingEvidenceChar123phaseDirChar125Char123runIdChar125RouteImport.update(
    {
      id: '/onboarding/evidence/{$phaseDir}/{$runId}',
      path: '/onboarding/evidence/{$phaseDir}/{$runId}',
      getParentRoute: () => rootRouteImport,
    } as any,
  );

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/conformidade': typeof ConformidadeRoute;
  '/inicio': typeof InicioRoute;
  '/testes-endpoint': typeof TestesEndpointRoute;
  '/documentacao/$api': typeof DocumentacaoApiRoute;
  '/onboarding/p{$phaseId}': typeof OnboardingPChar123phaseIdChar125Route;
  '/operacoes/busca': typeof OperacoesBuscaRoute;
  '/operacoes/dlq': typeof OperacoesDlqRoute;
  '/receptora/nova': typeof ReceptoraNovaRoute;
  '/receptora/retorno': typeof ReceptoraRetornoRoute;
  '/receptora/titular': typeof ReceptoraTitularRoute;
  '/aplicacoes/': typeof AplicacoesIndexRoute;
  '/consentimentos/': typeof ConsentimentosIndexRoute;
  '/convite/': typeof ConviteIndexRoute;
  '/dcr/': typeof DcrIndexRoute;
  '/documentacao/': typeof DocumentacaoIndexRoute;
  '/drift-regulatorio/': typeof DriftRegulatorioIndexRoute;
  '/indicadores/': typeof IndicadoresIndexRoute;
  '/login/': typeof LoginIndexRoute;
  '/monitoramento/': typeof MonitoramentoIndexRoute;
  '/onboarding/': typeof OnboardingIndexRoute;
  '/operacoes/': typeof OperacoesIndexRoute;
  '/pcm/': typeof PcmIndexRoute;
  '/primeiros-passos/': typeof PrimeirosPassosIndexRoute;
  '/receptora/': typeof ReceptoraIndexRoute;
  '/relatorio-diretor/': typeof RelatorioDiretorIndexRoute;
  '/usuarios/': typeof UsuariosIndexRoute;
  '/receptora/conexoes/$id': typeof ReceptoraConexoesIdRoute;
  '/onboarding/evidence/{$phaseDir}/{$runId}': typeof OnboardingEvidenceChar123phaseDirChar125Char123runIdChar125Route;
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/conformidade': typeof ConformidadeRoute;
  '/inicio': typeof InicioRoute;
  '/testes-endpoint': typeof TestesEndpointRoute;
  '/documentacao/$api': typeof DocumentacaoApiRoute;
  '/onboarding/p{$phaseId}': typeof OnboardingPChar123phaseIdChar125Route;
  '/operacoes/busca': typeof OperacoesBuscaRoute;
  '/operacoes/dlq': typeof OperacoesDlqRoute;
  '/receptora/nova': typeof ReceptoraNovaRoute;
  '/receptora/retorno': typeof ReceptoraRetornoRoute;
  '/receptora/titular': typeof ReceptoraTitularRoute;
  '/aplicacoes': typeof AplicacoesIndexRoute;
  '/consentimentos': typeof ConsentimentosIndexRoute;
  '/convite': typeof ConviteIndexRoute;
  '/dcr': typeof DcrIndexRoute;
  '/documentacao': typeof DocumentacaoIndexRoute;
  '/drift-regulatorio': typeof DriftRegulatorioIndexRoute;
  '/indicadores': typeof IndicadoresIndexRoute;
  '/login': typeof LoginIndexRoute;
  '/monitoramento': typeof MonitoramentoIndexRoute;
  '/onboarding': typeof OnboardingIndexRoute;
  '/operacoes': typeof OperacoesIndexRoute;
  '/pcm': typeof PcmIndexRoute;
  '/primeiros-passos': typeof PrimeirosPassosIndexRoute;
  '/receptora': typeof ReceptoraIndexRoute;
  '/relatorio-diretor': typeof RelatorioDiretorIndexRoute;
  '/usuarios': typeof UsuariosIndexRoute;
  '/receptora/conexoes/$id': typeof ReceptoraConexoesIdRoute;
  '/onboarding/evidence/{$phaseDir}/{$runId}': typeof OnboardingEvidenceChar123phaseDirChar125Char123runIdChar125Route;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  '/': typeof IndexRoute;
  '/conformidade': typeof ConformidadeRoute;
  '/inicio': typeof InicioRoute;
  '/testes-endpoint': typeof TestesEndpointRoute;
  '/documentacao/$api': typeof DocumentacaoApiRoute;
  '/onboarding/p{$phaseId}': typeof OnboardingPChar123phaseIdChar125Route;
  '/operacoes/busca': typeof OperacoesBuscaRoute;
  '/operacoes/dlq': typeof OperacoesDlqRoute;
  '/receptora/nova': typeof ReceptoraNovaRoute;
  '/receptora/retorno': typeof ReceptoraRetornoRoute;
  '/receptora/titular': typeof ReceptoraTitularRoute;
  '/aplicacoes/': typeof AplicacoesIndexRoute;
  '/consentimentos/': typeof ConsentimentosIndexRoute;
  '/convite/': typeof ConviteIndexRoute;
  '/dcr/': typeof DcrIndexRoute;
  '/documentacao/': typeof DocumentacaoIndexRoute;
  '/drift-regulatorio/': typeof DriftRegulatorioIndexRoute;
  '/indicadores/': typeof IndicadoresIndexRoute;
  '/login/': typeof LoginIndexRoute;
  '/monitoramento/': typeof MonitoramentoIndexRoute;
  '/onboarding/': typeof OnboardingIndexRoute;
  '/operacoes/': typeof OperacoesIndexRoute;
  '/pcm/': typeof PcmIndexRoute;
  '/primeiros-passos/': typeof PrimeirosPassosIndexRoute;
  '/receptora/': typeof ReceptoraIndexRoute;
  '/relatorio-diretor/': typeof RelatorioDiretorIndexRoute;
  '/usuarios/': typeof UsuariosIndexRoute;
  '/receptora/conexoes/$id': typeof ReceptoraConexoesIdRoute;
  '/onboarding/evidence/{$phaseDir}/{$runId}': typeof OnboardingEvidenceChar123phaseDirChar125Char123runIdChar125Route;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/conformidade'
    | '/inicio'
    | '/testes-endpoint'
    | '/documentacao/$api'
    | '/onboarding/p{$phaseId}'
    | '/operacoes/busca'
    | '/operacoes/dlq'
    | '/receptora/nova'
    | '/receptora/retorno'
    | '/receptora/titular'
    | '/aplicacoes/'
    | '/consentimentos/'
    | '/convite/'
    | '/dcr/'
    | '/documentacao/'
    | '/drift-regulatorio/'
    | '/indicadores/'
    | '/login/'
    | '/monitoramento/'
    | '/onboarding/'
    | '/operacoes/'
    | '/pcm/'
    | '/primeiros-passos/'
    | '/receptora/'
    | '/relatorio-diretor/'
    | '/usuarios/'
    | '/receptora/conexoes/$id'
    | '/onboarding/evidence/{$phaseDir}/{$runId}';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/conformidade'
    | '/inicio'
    | '/testes-endpoint'
    | '/documentacao/$api'
    | '/onboarding/p{$phaseId}'
    | '/operacoes/busca'
    | '/operacoes/dlq'
    | '/receptora/nova'
    | '/receptora/retorno'
    | '/receptora/titular'
    | '/aplicacoes'
    | '/consentimentos'
    | '/convite'
    | '/dcr'
    | '/documentacao'
    | '/drift-regulatorio'
    | '/indicadores'
    | '/login'
    | '/monitoramento'
    | '/onboarding'
    | '/operacoes'
    | '/pcm'
    | '/primeiros-passos'
    | '/receptora'
    | '/relatorio-diretor'
    | '/usuarios'
    | '/receptora/conexoes/$id'
    | '/onboarding/evidence/{$phaseDir}/{$runId}';
  id:
    | '__root__'
    | '/'
    | '/conformidade'
    | '/inicio'
    | '/testes-endpoint'
    | '/documentacao/$api'
    | '/onboarding/p{$phaseId}'
    | '/operacoes/busca'
    | '/operacoes/dlq'
    | '/receptora/nova'
    | '/receptora/retorno'
    | '/receptora/titular'
    | '/aplicacoes/'
    | '/consentimentos/'
    | '/convite/'
    | '/dcr/'
    | '/documentacao/'
    | '/drift-regulatorio/'
    | '/indicadores/'
    | '/login/'
    | '/monitoramento/'
    | '/onboarding/'
    | '/operacoes/'
    | '/pcm/'
    | '/primeiros-passos/'
    | '/receptora/'
    | '/relatorio-diretor/'
    | '/usuarios/'
    | '/receptora/conexoes/$id'
    | '/onboarding/evidence/{$phaseDir}/{$runId}';
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  ConformidadeRoute: typeof ConformidadeRoute;
  InicioRoute: typeof InicioRoute;
  TestesEndpointRoute: typeof TestesEndpointRoute;
  DocumentacaoApiRoute: typeof DocumentacaoApiRoute;
  OnboardingPChar123phaseIdChar125Route: typeof OnboardingPChar123phaseIdChar125Route;
  OperacoesBuscaRoute: typeof OperacoesBuscaRoute;
  OperacoesDlqRoute: typeof OperacoesDlqRoute;
  ReceptoraNovaRoute: typeof ReceptoraNovaRoute;
  ReceptoraRetornoRoute: typeof ReceptoraRetornoRoute;
  ReceptoraTitularRoute: typeof ReceptoraTitularRoute;
  AplicacoesIndexRoute: typeof AplicacoesIndexRoute;
  ConsentimentosIndexRoute: typeof ConsentimentosIndexRoute;
  ConviteIndexRoute: typeof ConviteIndexRoute;
  DcrIndexRoute: typeof DcrIndexRoute;
  DocumentacaoIndexRoute: typeof DocumentacaoIndexRoute;
  DriftRegulatorioIndexRoute: typeof DriftRegulatorioIndexRoute;
  IndicadoresIndexRoute: typeof IndicadoresIndexRoute;
  LoginIndexRoute: typeof LoginIndexRoute;
  MonitoramentoIndexRoute: typeof MonitoramentoIndexRoute;
  OnboardingIndexRoute: typeof OnboardingIndexRoute;
  OperacoesIndexRoute: typeof OperacoesIndexRoute;
  PcmIndexRoute: typeof PcmIndexRoute;
  PrimeirosPassosIndexRoute: typeof PrimeirosPassosIndexRoute;
  ReceptoraIndexRoute: typeof ReceptoraIndexRoute;
  RelatorioDiretorIndexRoute: typeof RelatorioDiretorIndexRoute;
  UsuariosIndexRoute: typeof UsuariosIndexRoute;
  ReceptoraConexoesIdRoute: typeof ReceptoraConexoesIdRoute;
  OnboardingEvidenceChar123phaseDirChar125Char123runIdChar125Route: typeof OnboardingEvidenceChar123phaseDirChar125Char123runIdChar125Route;
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/conformidade': {
      id: '/conformidade';
      path: '/conformidade';
      fullPath: '/conformidade';
      preLoaderRoute: typeof ConformidadeRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/inicio': {
      id: '/inicio';
      path: '/inicio';
      fullPath: '/inicio';
      preLoaderRoute: typeof InicioRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/testes-endpoint': {
      id: '/testes-endpoint';
      path: '/testes-endpoint';
      fullPath: '/testes-endpoint';
      preLoaderRoute: typeof TestesEndpointRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/aplicacoes/': {
      id: '/aplicacoes/';
      path: '/aplicacoes';
      fullPath: '/aplicacoes/';
      preLoaderRoute: typeof AplicacoesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/consentimentos/': {
      id: '/consentimentos/';
      path: '/consentimentos';
      fullPath: '/consentimentos/';
      preLoaderRoute: typeof ConsentimentosIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/convite/': {
      id: '/convite/';
      path: '/convite';
      fullPath: '/convite/';
      preLoaderRoute: typeof ConviteIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/dcr/': {
      id: '/dcr/';
      path: '/dcr';
      fullPath: '/dcr/';
      preLoaderRoute: typeof DcrIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/documentacao/': {
      id: '/documentacao/';
      path: '/documentacao';
      fullPath: '/documentacao/';
      preLoaderRoute: typeof DocumentacaoIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/documentacao/$api': {
      id: '/documentacao/$api';
      path: '/documentacao/$api';
      fullPath: '/documentacao/$api';
      preLoaderRoute: typeof DocumentacaoApiRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/drift-regulatorio/': {
      id: '/drift-regulatorio/';
      path: '/drift-regulatorio';
      fullPath: '/drift-regulatorio/';
      preLoaderRoute: typeof DriftRegulatorioIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/indicadores/': {
      id: '/indicadores/';
      path: '/indicadores';
      fullPath: '/indicadores/';
      preLoaderRoute: typeof IndicadoresIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/login/': {
      id: '/login/';
      path: '/login';
      fullPath: '/login/';
      preLoaderRoute: typeof LoginIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/monitoramento/': {
      id: '/monitoramento/';
      path: '/monitoramento';
      fullPath: '/monitoramento/';
      preLoaderRoute: typeof MonitoramentoIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/onboarding/': {
      id: '/onboarding/';
      path: '/onboarding';
      fullPath: '/onboarding/';
      preLoaderRoute: typeof OnboardingIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/onboarding/p{$phaseId}': {
      id: '/onboarding/p{$phaseId}';
      path: '/onboarding/p{$phaseId}';
      fullPath: '/onboarding/p{$phaseId}';
      preLoaderRoute: typeof OnboardingPChar123phaseIdChar125RouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/operacoes/': {
      id: '/operacoes/';
      path: '/operacoes';
      fullPath: '/operacoes/';
      preLoaderRoute: typeof OperacoesIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/operacoes/busca': {
      id: '/operacoes/busca';
      path: '/operacoes/busca';
      fullPath: '/operacoes/busca';
      preLoaderRoute: typeof OperacoesBuscaRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/operacoes/dlq': {
      id: '/operacoes/dlq';
      path: '/operacoes/dlq';
      fullPath: '/operacoes/dlq';
      preLoaderRoute: typeof OperacoesDlqRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/pcm/': {
      id: '/pcm/';
      path: '/pcm';
      fullPath: '/pcm/';
      preLoaderRoute: typeof PcmIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/primeiros-passos/': {
      id: '/primeiros-passos/';
      path: '/primeiros-passos';
      fullPath: '/primeiros-passos/';
      preLoaderRoute: typeof PrimeirosPassosIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/receptora/': {
      id: '/receptora/';
      path: '/receptora';
      fullPath: '/receptora/';
      preLoaderRoute: typeof ReceptoraIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/receptora/nova': {
      id: '/receptora/nova';
      path: '/receptora/nova';
      fullPath: '/receptora/nova';
      preLoaderRoute: typeof ReceptoraNovaRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/receptora/retorno': {
      id: '/receptora/retorno';
      path: '/receptora/retorno';
      fullPath: '/receptora/retorno';
      preLoaderRoute: typeof ReceptoraRetornoRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/receptora/titular': {
      id: '/receptora/titular';
      path: '/receptora/titular';
      fullPath: '/receptora/titular';
      preLoaderRoute: typeof ReceptoraTitularRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/relatorio-diretor/': {
      id: '/relatorio-diretor/';
      path: '/relatorio-diretor';
      fullPath: '/relatorio-diretor/';
      preLoaderRoute: typeof RelatorioDiretorIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/usuarios/': {
      id: '/usuarios/';
      path: '/usuarios';
      fullPath: '/usuarios/';
      preLoaderRoute: typeof UsuariosIndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/receptora/conexoes/$id': {
      id: '/receptora/conexoes/$id';
      path: '/receptora/conexoes/$id';
      fullPath: '/receptora/conexoes/$id';
      preLoaderRoute: typeof ReceptoraConexoesIdRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    '/onboarding/evidence/{$phaseDir}/{$runId}': {
      id: '/onboarding/evidence/{$phaseDir}/{$runId}';
      path: '/onboarding/evidence/{$phaseDir}/{$runId}';
      fullPath: '/onboarding/evidence/{$phaseDir}/{$runId}';
      preLoaderRoute: typeof OnboardingEvidenceChar123phaseDirChar125Char123runIdChar125RouteImport;
      parentRoute: typeof rootRouteImport;
    };
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConformidadeRoute: ConformidadeRoute,
  InicioRoute: InicioRoute,
  TestesEndpointRoute: TestesEndpointRoute,
  DocumentacaoApiRoute: DocumentacaoApiRoute,
  OnboardingPChar123phaseIdChar125Route: OnboardingPChar123phaseIdChar125Route,
  OperacoesBuscaRoute: OperacoesBuscaRoute,
  OperacoesDlqRoute: OperacoesDlqRoute,
  ReceptoraNovaRoute: ReceptoraNovaRoute,
  ReceptoraRetornoRoute: ReceptoraRetornoRoute,
  ReceptoraTitularRoute: ReceptoraTitularRoute,
  AplicacoesIndexRoute: AplicacoesIndexRoute,
  ConsentimentosIndexRoute: ConsentimentosIndexRoute,
  ConviteIndexRoute: ConviteIndexRoute,
  DcrIndexRoute: DcrIndexRoute,
  DocumentacaoIndexRoute: DocumentacaoIndexRoute,
  DriftRegulatorioIndexRoute: DriftRegulatorioIndexRoute,
  IndicadoresIndexRoute: IndicadoresIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  MonitoramentoIndexRoute: MonitoramentoIndexRoute,
  OnboardingIndexRoute: OnboardingIndexRoute,
  OperacoesIndexRoute: OperacoesIndexRoute,
  PcmIndexRoute: PcmIndexRoute,
  PrimeirosPassosIndexRoute: PrimeirosPassosIndexRoute,
  ReceptoraIndexRoute: ReceptoraIndexRoute,
  RelatorioDiretorIndexRoute: RelatorioDiretorIndexRoute,
  UsuariosIndexRoute: UsuariosIndexRoute,
  ReceptoraConexoesIdRoute: ReceptoraConexoesIdRoute,
  OnboardingEvidenceChar123phaseDirChar125Char123runIdChar125Route:
    OnboardingEvidenceChar123phaseDirChar125Char123runIdChar125Route,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
